import { render, staticRenderFns } from "./LayoutMenuTall.vue?vue&type=template&id=4fb27cef&scoped=true&"
import script from "./LayoutMenuTall.vue?vue&type=script&lang=js&"
export * from "./LayoutMenuTall.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMenuTall.vue?vue&type=style&index=0&id=4fb27cef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb27cef",
  null
  
)

export default component.exports